const $ = jQuery.noConflict();

class ajaxFilterPosts {
    constructor( container, content, filterSelect, filterTabs, filterYear, filterTypes, filterPagination )  {
		this.container = $(container);
		this.content   = this.container.find(content);
		this.filterSelect = this.container.find(filterSelect);
		this.filterTabs = this.container.find(filterTabs);
		this.filterYear = this.container.find(filterYear);
		this.filterPagination = this.container.find(filterPagination);
		this.filterSearch = $('#apf_search');
		this.resetSearch = $('.ajax-filter-posts-search__clear');
		this.multiTypes = this.container.find(filterTypes);
		this.mobileTrigger = $('.ajax-filter-posts-mobile-trigger');
    }

    init() {
		this.filterSelect.on('click', this.filterPosts);
		this.filterTabs.on('click', this.filterPosts);
		this.filterYear.on('click', this.filterPosts);
		this.multiTypes.on('click', this.filterPosts);
		this.filterPagination.on('click', this.loadMore);

		this.filterSearch.on('keypress', this.searchPosts);
		this.container.on('submit', 'form', function (e) {
			e.preventDefault();
		});
		this.resetSearch.on('click', this.searchReset);

		$('div.ajax-filter-posts-nav-title').on('click', this.openerToggler);
		$('div.ajax-filter-posts-tabs-title').on('click', this.openerToggler);
		$('div.ajax-filter-posts-year-title').on('click', this.openerToggler);
		$('div.ajax-filter-posts-types-title').on('click', this.openerToggler);
		$(document).on('mouseup', function (e) {
			var div = $('div.ajax-filter-posts-nav-title');
			if (!div.is(e.target)
				&& div.has(e.target).length === 0) {
				div.removeClass('open');
			}
		});
		if ($('.ajax-filter-posts-tabs').length > 0) {
			$(document).on('mouseup', function (e) {
				var div = $('div.ajax-filter-posts-tabs-title');
				if (!div.is(e.target)
					&& div.has(e.target).length === 0) {
					div.removeClass('open');
				}
			});
		}
		if ($('.ajax-filter-posts-year').length > 0) {
			$(document).on('mouseup', function (e) {
				var div = $('div.ajax-filter-posts-year-title');
				if (!div.is(e.target)
					&& div.has(e.target).length === 0) {
					div.removeClass('open');
				}
			});
		}
		if ($('.ajax-filter-posts-types').length > 0) {
			$(document).on('mouseup', function (e) {
				var div = $('div.ajax-filter-posts-types-title');
				if (!div.is(e.target)
					&& div.has(e.target).length === 0) {
					div.removeClass('open');
				}
			});
		}

		// Mobile-trigger handler
		$('.ajax-filter-posts-mobile-trigger').on('click', 'h4', function (e) {
			e.preventDefault();
			$(this).parent().toggleClass('opened');
		});

		// Reset filters
		$('#ajax-filter-posts-container').on('click', '.ajax-filter-posts-reset button', function (event) {
			if (event.preventDefault) { event.preventDefault(); }
			$('#apf_search').val('');
			$('.ajax-filter-posts-search__clear').removeClass('active');
			$('.ajax-filter-posts-mobile-trigger').removeClass('opened')
			$('a[data-term="all-terms"]').trigger('click');;
			$(this).trigger('blur');
		});
		// Reset search
		$('#ajax-filter-posts-container').on('click', '.ajax-filter-posts-search__clear', function (event) {
			if (event.preventDefault) { event.preventDefault(); }
			$('#apf_search').val('');
			$('ul.ajax-filter-posts-nav-filter').find('.active a').trigger('click');
			$(this).removeClass('active');
			$(this).trigger('blur');
		});

		/**
		 * Handler for in-card tax buttons
		 */
		$('.apf-has-filter-triggers').on('click', '.apf-filter-trigger', function (e) {
			e.preventDefault();

			let termSlug = $(this).data('term');
			$('ul.ajax-filter-posts-nav-filter').find('a[data-term="'+termSlug+'"]').trigger('click');
		});

		/**
		 * Handler for accordions
		 */
		$('.apf-has-accordions').on('click', '.bellow__title', function (e) {
			e.preventDefault();
			$(this).parent().toggleClass('active');
			$(this).next().stop().slideToggle(250);
		});
    }

	/**
	 * Bind get_posts to tag cloud and navigation
	 */
	filterPosts(event) {
		if (event.preventDefault) { event.preventDefault(); }

			let apfTrigger = $(this);

			let mainContainer = document.querySelector('#ajax-filter-posts-container');

			let page        = mainContainer.getAttribute('data-page');
			let postPerPage = mainContainer.getAttribute('data-paged');
			let tax;
			let term;
			let tab;
			let year;
			let search      = document.querySelector('#apf_search').value;

			/**
			 * Set filter active
			 */
			if (apfTrigger.data('filter')) {
				apfTrigger.closest('ul').find('.active').removeClass('active');
				apfTrigger.parent('li').addClass('active');

				var itemSelected = apfTrigger.text();
				if (apfTrigger.data('termlabel')) {
					itemSelected = apfTrigger.data('termlabel');
					$('div.ajax-filter-posts-nav-title').removeClass('selected');
				} else {
					$('div.ajax-filter-posts-nav-title').addClass('selected');
				}
				$('div.ajax-filter-posts-nav-title').text(itemSelected);

				page = 1;
				mainContainer.setAttribute('data-currentpage', page);

				tax = apfTrigger.data('filter');
				term = apfTrigger.data('term');

				tab  = $('.ajax-filter-posts-tabs-filter .active a').data('tab');
				year = '';
				$('div.ajax-filter-posts-year-title').text('Year');
				$('div.ajax-filter-posts-year-title').removeClass('selected');
			}
			else if (apfTrigger.data('tab')) {
				apfTrigger.closest('ul').find('.active').removeClass('active');
				apfTrigger.parent('li').addClass('active');
				tab = apfTrigger.data('tab');

				var itemTabSelected = apfTrigger.text();
				$('div.ajax-filter-posts-tabs-title').text(itemTabSelected);

				apfTrigger = document.querySelector('.ajax-filter-posts-nav-filter .active a');
				tax = apfTrigger.getAttribute('data-filter');
				term = apfTrigger.getAttribute('data-term');

			}
			else if (apfTrigger.data('year')) {
				apfTrigger.closest('ul').find('.active').removeClass('active');
				if ( 'all-dates' === apfTrigger.data('year') ) {
					year = '';
					$('div.ajax-filter-posts-year-title').text('Year');
					$('div.ajax-filter-posts-year-title').removeClass('selected');
				} else {
					apfTrigger.parent('li').addClass('active');
					year = apfTrigger.data('year');

					var itemYearSelected = apfTrigger.text();
					$('div.ajax-filter-posts-year-title').text('Year: '+itemYearSelected);
					$('div.ajax-filter-posts-year-title').addClass('selected');
				}

				apfTrigger = document.querySelector('.ajax-filter-posts-nav-filter .active a');
				tax = apfTrigger.getAttribute('data-filter');
				term = apfTrigger.getAttribute('data-term');

			}
			else if (apfTrigger.data('types')) {
				apfTrigger.closest('ul').find('.active').removeClass('active');
				apfTrigger.parent('li').addClass('active');

				var itemTypeSelected = apfTrigger.text();
				$('div.ajax-filter-posts-types-title').text(itemTypeSelected);

				itemTypeSelected = apfTrigger.data('types');
				mainContainer.setAttribute('data-posttype', itemTypeSelected);

				apfTrigger = document.querySelector('.ajax-filter-posts-nav-filter .active a');
				tax = apfTrigger.getAttribute('data-filter');
				term = apfTrigger.getAttribute('data-term');

			}

			let params = {
				'tabs': mainContainer.getAttribute('data-tabs'),
				'tab': tab,
				'year': year,
				'search': search,
				'tax': tax,
				'term': term,
				'qty': postPerPage,
				'page': mainContainer.getAttribute('data-page'),
				'post_type': mainContainer.getAttribute('data-posttype'),
			};

		// Run query
		ajaxFilterPosts.get_posts(params);
	}

	loadMore() {
		if (event.preventDefault) { event.preventDefault(); }

		let mainContainer = document.querySelector('#ajax-filter-posts-container');

		let postPerPage = mainContainer.getAttribute('data-paged');

		let apfTrigger = document.querySelector('.ajax-filter-posts-nav-filter .active a');

		let post_type = mainContainer.getAttribute('data-posttype');
		let tax       = apfTrigger.getAttribute('data-filter');
		let term      = apfTrigger.getAttribute('data-term');
		let tabs      = mainContainer.getAttribute('data-tabs');
		let tab       =  '';
		let year;
		let page      = mainContainer.getAttribute('data-page');
		let search    = document.querySelector('#apf_search').value;

		// Load More button
		let updatedPageCount = mainContainer.getAttribute('data-currentpage');
		if( updatedPageCount ) {
			updatedPageCount = Number(updatedPageCount) + 1;
		} else {
			updatedPageCount = Number(mainContainer.getAttribute('data-page')) + 1;
		}
		mainContainer.setAttribute('data-currentpage', updatedPageCount);

		let loadOnPage = updatedPageCount * postPerPage;

		let params = {
			'tabs': tabs,
			'tab': tab,
			'year': year,
			'search': search,
			'tax': tax,
			'term': term,
			'qty': loadOnPage,
			'page': page,
			'post_type': post_type
		};

		// Run query
		ajaxFilterPosts.get_posts(params);
	}

	searchPosts(eventObject) {
		/**
		 * Search handler
		 */
		let search = '';
		let apfSearch     = document.querySelector('#apf_search');
		let mainContainer = document.querySelector('#ajax-filter-posts-container');
		let apfTrigger    = document.querySelector('.ajax-filter-posts-nav-filter .active a');

		let post_type  = mainContainer.getAttribute('data-posttype');
		let tax        = apfTrigger.getAttribute('data-filter');
		let term       = apfTrigger.getAttribute('data-term');
		let tabs       = '';
		let tab        = '';
		let year;
		let page       = mainContainer.getAttribute('data-page');
		let loadOnPage = mainContainer.getAttribute('data-currentpage') * mainContainer.getAttribute('data-paged');

		var searchTerm = $(this).val();

		if (searchTerm.length > 0) {
			$(this).nextAll('.ajax-filter-posts-search__clear').addClass('active');
		}
		if (searchTerm.length > 2) {
			search = searchTerm;

			let params = {
				'page': 1,
				'tax': tax,
				'term': term,
				'tabs': tabs,
				'tab': tab,
				'year': year,
				'qty': loadOnPage,
				'post_type': post_type,
				'search': search
			};
			ajaxFilterPosts.get_posts(params);
		}
	}


	/**
	 * Retrieve posts
	 */
	static get_posts(params) {

		let container = $('#ajax-filter-posts-container');
		let status    = $('.ajax-filter-posts-status');
		let content   = container.find('.ajax-filter-posts-content');
		this.params   = params;

		container.addClass('disabled');
		status.text('Loading ...');

		$.ajax({
			url: archiveloop.ajax_url,
			data: {
				action: 'do_filter_posts',
				nonce: archiveloop.nonce,
				params: this.params
			},
			type: 'post',
			dataType: 'json',
			success: function (data, textStatus, XMLHttpRequest) {

				if (data.status === 200) {
					content.html(data.content);
				} else if (data.status === 201) {
					content.html(data.message);
				} else {
					status.html(data.message);
				}
			},
			error: function (MLHttpRequest, textStatus, errorThrown) {

				status.html(textStatus);

			},
			complete: function (data, textStatus) {

				let msg = textStatus;

				if (textStatus === 'success') {
					msg = data.responseJSON.found;

					let mainContainerContainer = document.querySelector('#ajax-filter-posts-container');
					let postPerPage = mainContainerContainer.getAttribute('data-paged');
					let updatedPageCount = mainContainerContainer.getAttribute('data-currentpage');
					let loadedOnPage = updatedPageCount * postPerPage;

					if ( msg < loadedOnPage ) {
						var pagination = document.getElementById("ajax-filter-posts-pagination");
						pagination.style.display = "none";
					} else {
						var pagination = document.getElementById("ajax-filter-posts-pagination");
						pagination.style.display = "block";
					}
				}

				status.text('Posts found: ' + msg);
				container.removeClass('disabled');
			}
		});
	}

	loadDefault() {

		let apfTerm = 'all-terms';

		/**
		 * Get URL params and load posts if there are any
		 */
		const queryString = window.location.search;
		if (queryString.length > 0) {
			const urlParams = new URLSearchParams(queryString);
			const apfTax = $('.ajax-filter-posts-nav-filter li:last-child a').data('filter');
			for(let [name, value] of urlParams) {
				if ( name == apfTax ) {
					apfTerm = value;
				}
			}
		}
		/**
		 * Load all by default
		 */
		$('a[data-term="'+apfTerm+'"]').trigger('click');
	}

	/**
	 * Helpers
	 */
	openerToggler() {
		$(this).toggleClass('open');
	}
}

export default new ajaxFilterPosts(
	'#ajax-filter-posts-container',
	'.ajax-filter-posts-content',
	'a[data-filter]',
	'a[data-tab]',
	'a[data-year]',
	'a[data-types]',
	'#ajax-filter-posts-pagination'
);
